module["exports"] = [
  "a mare",
  "lido",
  "ligure",
  "del friuli",
  "salentino",
  "calabro",
  "veneto",
  "nell'emilia",
  "umbro",
  "laziale",
  "terme",
  "sardo"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/city_suffix.js
// module id = 1772
// module chunks = 0